/** Cross-app lobby handoff helpers. */

const LOBBY_DEFAULT = 'http://127.0.0.1:18810/'

export function lobbyURLFromEnv(envLobby?: string): string {
  const fromEnv = (envLobby || '').trim()
  if (fromEnv) return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`
  try {
    const q = new URLSearchParams(window.location.search).get('lobby')
    if (q) {
      const u = decodeURIComponent(q)
      return u.endsWith('/') ? u : `${u}/`
    }
  } catch {
    /* ignore */
  }
  return LOBBY_DEFAULT
}

/** Navigate back to lobby, optionally carrying JWT for handoff. */
export function goLobby(token: string | null | undefined, envLobby?: string): void {
  const base = lobbyURLFromEnv(envLobby)
  try {
    const u = new URL(base, window.location.href)
    if (token) u.searchParams.set('token', token)
    window.location.href = u.toString()
  } catch {
    const sep = base.includes('?') ? '&' : '?'
    window.location.href = token
      ? `${base}${sep}token=${encodeURIComponent(token)}`
      : base
  }
}

export function takeTokenFromUrl(): string | null {
  try {
    const u = new URL(window.location.href)
    const t = u.searchParams.get('token')
    if (t) {
      u.searchParams.delete('token')
      window.history.replaceState({}, '', u.pathname + u.search + u.hash)
      return t
    }
  } catch {
    /* ignore */
  }
  return null
}
